import React from 'react';

/**
 * LinkedIn Insight Tag — conversion + Matched Audience retargeting.
 * Free to install; does NOT export person names to Razzmatazz.
 * Partner id from Campaign Manager → Analyze → Insight Tag.
 */
const LinkedInInsightTag: React.FC = () => {
  const partnerId = (process.env.REACT_APP_LINKEDIN_INSIGHT_PARTNER_ID || '').trim();
  React.useEffect(() => {
    if (!partnerId || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    const w = window as Window & { _linkedin_partner_id?: string; _linkedin_data_partner_ids?: string[] };
    w._linkedin_partner_id = partnerId;
    w._linkedin_data_partner_ids = w._linkedin_data_partner_ids || [];
    if (!w._linkedin_data_partner_ids.includes(partnerId)) {
      w._linkedin_data_partner_ids.push(partnerId);
    }
    if (!document.getElementById('linkedin-insight-tag')) {
      const script = document.createElement('script');
      script.id = 'linkedin-insight-tag';
      script.async = true;
      script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      document.body.appendChild(script);
    }
    if (!document.getElementById('linkedin-insight-noscript')) {
      const img = document.createElement('img');
      img.id = 'linkedin-insight-noscript';
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.alt = '';
      img.src = `https://px.ads.linkedin.com/collect/?pid=${encodeURIComponent(partnerId)}&fmt=gif`;
      document.body.appendChild(img);
    }
  }, [partnerId]);
  return null;
};

export default LinkedInInsightTag;
